module.exports = __webpack_public_path__ + "static/media/verisign.3684cf82.svg";